import { render, staticRenderFns } from "./newTag.vue?vue&type=template&id=b67a6ebc&scoped=true&"
import script from "./newTag.vue?vue&type=script&lang=js&"
export * from "./newTag.vue?vue&type=script&lang=js&"
import style0 from "./newTag.vue?vue&type=style&index=0&id=b67a6ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b67a6ebc",
  null
  
)

export default component.exports